import scrollToTopMobile from 'shared/experiments/browser/SerpLoadMore/scrollToTopMobile'
import { subscribe } from 'shared/store'
import { SEARCH_RESULTS_HITS_UPDATED } from 'shared/store/ducks/events'
import chargeUrlSearchParams from 'views/assets/scripts/chargeUrlSearchParams'
import runScripts from 'views/assets/scripts/runScripts'
import initClientScriptsXsellSellerModal from 'views/components/organisms/XsellSellerModal/initClientScripts'
import mountAlgoliaSearchComponent from 'views/containers/browser/AlgoliaInstantSearchContainer/mountAlgoliaSearchComponent'
import mountNowShippingModalContainer from 'views/containers/browser/NowShippingModalContainer/mountNowShippingModalContainer'
import mountSellerModalContainer from 'views/containers/browser/SellerModalContainer/mountSellerModalContainer'
import mountVolumePricingModalContainer from 'views/containers/browser/VolumePricingModalContainer/mountVolumePricingModalContainer'

const handleSellerModalContainer = () => {
  /**
   * Do not reload mountSellerModalContainer on first only
   * after clicking on pagination links on category search results page
   */
  let isSearchPageLoaded = false
  /**
   * We need to recall mountSellerModalContainer function as when we click on pagination link
   * on category search results page, Seller Modal is not loading contents due to the bug where click
   * handler is not registering dynamically added links for seller modal.
   */
  subscribe.after(SEARCH_RESULTS_HITS_UPDATED, () => {
    if (isSearchPageLoaded) {
      /**
       * we call it here again, so we can reattach click handler on seller links after
       * they are dynamically loaded on click on pagination links.
       */
      mountSellerModalContainer()
    }
    isSearchPageLoaded = true
  })
}

runScripts(
  mountAlgoliaSearchComponent,
  mountNowShippingModalContainer,
  mountVolumePricingModalContainer,
  initClientScriptsXsellSellerModal,
  scrollToTopMobile,
  chargeUrlSearchParams,
  handleSellerModalContainer
)
